import { Component, type ReactNode } from 'react'

export class WorkspaceErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() { return { failed: true } }
  render() {
    if (this.state.failed) return <div className="pc-page"><div className="pc-error" role="alert"><h2 className="font-semibold mb-2">Не удалось открыть раздел</h2><p>Обновите страницу. Если ошибка повторится, откройте другой раздел через меню.</p><button className="pc-link underline mt-3" onClick={() => window.location.reload()}>Обновить страницу</button></div></div>
    return this.props.children
  }
}
